import React from "react";

import Section from "./Section";
import Navbars from "../../Layout/Navbar";



const PrivacyPolicy = () => {

  return (
    <React.Fragment>
      <Navbars isDark={false} />
      <Section />
    </React.Fragment>
  );
};

export default PrivacyPolicy;
